import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

// Collapsible accordion card. Parent controls `open` (one open at a time,
// typically driven by a URL ?tab= param).
export const TabCard = ({ id, icon, accent, title, subtitle, badge, badgeTone = 'pink', open, onToggle, children }) => {
  const toneCls = badgeTone === 'green'
    ? 'bg-[#06D6A0]/15 text-[#058B69]'
    : badgeTone === 'amber'
      ? 'bg-[#FFF4E6] text-[#B8860B] border border-[#FFD9A8]'
      : badgeTone === 'indigo'
        ? 'bg-[#6366F1]/10 text-[#4F46E5]'
        : 'bg-[#FF3B6B]/10 text-[#FF3B6B]';
  return (
    <div className="bg-white rounded-2xl border border-[#E8E5DF] overflow-hidden" data-testid={`tab-card-${id}`}>
      <button
        onClick={onToggle}
        aria-expanded={open}
        className="w-full flex items-center gap-3 p-4 sm:p-5 min-h-[60px] text-left hover:bg-[#FFFDF8] transition-colors"
        data-testid={`tab-header-${id}`}
      >
        <span className={`w-10 h-10 rounded-xl flex items-center justify-center flex-none ${accent}`}>{icon}</span>
        <span className="flex-1 min-w-0">
          <span className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-[#1E1E24] text-base sm:text-lg" style={{ fontFamily: 'Fredoka' }}>{title}</span>
            {badge != null && badge !== '' && (
              <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${toneCls}`} data-testid={`tab-badge-${id}`}>{badge}</span>
            )}
          </span>
          {subtitle && <span className="block text-xs text-[#6B6B7A] mt-0.5 truncate">{subtitle}</span>}
        </span>
        <ChevronDown className={`w-5 h-5 text-[#6B6B7A] flex-none transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="body"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.28, ease: 'easeInOut' }}
            style={{ overflow: 'hidden' }}
          >
            <div className="px-4 sm:px-5 pb-5 pt-1 border-t border-[#F0EEE9]" data-testid={`tab-body-${id}`}>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TabCard;
